<section>
  <div>
      <div class="c-form-row">
        <div class="c-form-column">
          <div class="input-container">
              <h1 class="-blue">Deseja Exportar as configurações para as empresas que foram selecionadas?</h1>
              <button class="o-button -blue" (click)="exportList();">Sim</button>
              <button class="o-button -white" (click)="close();">Cancelar</button>
          </div>
        </div>
      </div>
  </div>
</section>